import { useEffect, useState } from "react";
import firebase, { mainDatabase } from "./firebase";
import { serverNowMsFromOffset } from "./serverTimeMs";

/** RTDB offset between this device and Firebase servers (ms). Undefined until the first `.info` snapshot. */
export function useServerTimeOffsetMs(): number | undefined {
    const [offsetMs, setOffsetMs] = useState<number | undefined>(undefined);

    useEffect(() => {
        const ref = mainDatabase.ref(".info/serverTimeOffset");
        const onValue = (snap: firebase.database.DataSnapshot) => {
            const raw = snap.val();
            setOffsetMs(typeof raw === "number" && Number.isFinite(raw) ? raw : 0);
        };
        ref.on("value", onValue);
        return () => ref.off("value", onValue);
    }, []);

    return offsetMs;
}

export { serverNowMsFromOffset } from "./serverTimeMs";

/** Trusted "now" from Firebase RTDB (production clock). Undefined until offset is known. */
export function useServerNow(): Date | undefined {
    const ms = useServerNowMs();
    return ms === undefined ? undefined : new Date(ms);
}

/** Same clock as {@link useServerNow}, as epoch ms for RTDB fields (`startedAt`, `orderedAt`, …). */
export function useServerNowMs(): number | undefined {
    const offsetMs = useServerTimeOffsetMs();
    return serverNowMsFromOffset(offsetMs);
}
